<script setup lang="ts">
import { computed } from 'vue'
import { KsButton, KsInput } from '@aschehoug/kloss'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../../stores/auth'
import { useI18n } from 'vue-i18n'
import arrayUtils from '../../utils/arrayUtils'
import { gradesSorted } from '~/utils/gradeSorter'

const { t } = useI18n()
const { unique } = arrayUtils()

const authStore = useAuthStore()
const { toggleGrade, hasGrade } = authStore
const { userGrades, userGradesBySubjects } = storeToRefs(authStore)

const relevantGrades = computed(() => userGradesBySubjects.value.length
  ? userGradesBySubjects.value.concat(userGrades.value).filter(unique)
  : gradesSorted,
)
</script>
<template>
  <div>
    <p
      class="text-center text-gray-40"
      v-text="t('filters.chooseGrade')"
    />
    <form class="mt-6 flex flex-wrap justify-center gap-3">
      <KsButton
        v-for="grade in relevantGrades"
        :key="grade"
        type="label"
        variant="secondary"
        shape="rounded"
      >
        <KsInput
          type="checkbox"
          name="grade"
          :checked="hasGrade(grade)"
          :value="grade"
          @click="toggleGrade(grade)"
        />
        {{ t(`metadata.grades.${grade}`) }}
      </KsButton>
    </form>
  </div>
</template>
